import QuestionIcon from "@/components/common/QuestionIcon";
import { useScrollLock } from "@/hooks/useScrollLock";
import { Grid, Modal, Tooltip } from "antd";
import React, { useState } from "react";

interface MobileTooltipProps {
  /** Tooltip/弹窗内容 */
  content: React.ReactNode;
  /** 弹窗标题（移动端使用） */
  title?: string;
  /** 问号图标大小，默认18 */
  iconSize?: number;
  /** Tooltip 位置，默认 bottomLeft */
  placement?:
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "topLeft"
    | "topRight"
    | "bottomLeft"
    | "bottomRight";
  /** 自定义触发元素（可选，默认为问号图标） */
  children?: React.ReactNode;
  /** 自定义类名 */
  className?: string;
}

/**
 * 移动端自适应 Tooltip 组件
 * - PC端：显示 Ant Design Tooltip
 * - 移动端：点击显示 Modal 弹窗
 */
const MobileTooltip: React.FC<MobileTooltipProps> = ({
  content,
  title = "提示",
  iconSize = 18,
  placement = "bottomLeft",
  children,
  className,
}) => {
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;
  const [modalVisible, setModalVisible] = useState(false);

  // 防止移动端滚动穿透
  useScrollLock(modalVisible);

  const triggerElement = children || (
    <div className={`tooltip-trigger ${className || ""}`}>
      <QuestionIcon size={iconSize} />
    </div>
  );

  if (isMobile) {
    // 移动端：点击打开弹窗
    return (
      <>
        <div
          onClick={() => setModalVisible(true)}
          style={{ cursor: "pointer" }}
        >
          {triggerElement}
        </div>
        <Modal
          open={modalVisible}
          onCancel={() => setModalVisible(false)}
          footer={null}
          title={title}
          centered
          className="mobile-tooltip-modal"
        >
          <div
            style={{
              whiteSpace: "pre-line",
              lineHeight: 1.8,
              fontSize: 14,
              color: "#374151",
            }}
          >
            {content}
          </div>
        </Modal>
      </>
    );
  }

  // PC端：保持 Tooltip
  return (
    <Tooltip
      title={<div style={{ whiteSpace: "pre-line" }}>{content}</div>}
      placement={placement}
      trigger={["click", "hover"]}
    >
      {triggerElement}
    </Tooltip>
  );
};

export default MobileTooltip;
